export default {
  app: {
    name: '跑腿兄弟',
    evaluation: '{star_num} 星 ({comment_num} 萬則評分)'
  },
  redirect: {
    launch_app: '在 App 中繼續',
    redirect_app_only_in_production: '請在生產環境中開啟',
    detect_device_os_failure: '檢測裝置操作系統失敗',
  },
  general: {
    system_bulletin: '系統公告',
    no_record: '無資料',
    cancel: '取消',
    confirm: '確認',
    enter: '確定',
    save: '儲存',
    submit: '送出',
    edit: '編輯',
    delete: '刪除',
    required_field: '必填',
    change: '更改',
    modify: '變更',
    close: '關閉',
    apply: '套用',
    back: '返回',
    save_failed: '儲存失敗',
    delete_confirm: '確定要刪除嗎',
    delete_failed: '刪除失敗',
    delete_successful: '成功刪除',
    authorizing: '授權中...',
    agree: '同意',
    disagree: '不同意',
    next_step: '下一步',
    send: '發送',
    system_alert: '系統提示',
    new: '新增',
    dollar: '元',
    dollar_sign: '$',
    minute: '分鐘',
    distance_unit: '公里',
    distance_unit_en: 'km',
    weight_unit: '公斤',
    dont_use: '不使用',
    agreement_read: '已閱讀並同意',
    read_agreement: '請閱讀並同意',
    number: '編號',
    login: '請先登入',
    slowdown: '請點慢一點~',
    setting: '設定',
    or: '或',
    continue: '繼續',
    rechoose: '重新選擇',
    point_unit: '跑幣',
    go_detail: '查看明細',
    more: '更多',
    select_all: '全選',
    pulltext: '下拉刷新',
    droptext: '放開更新',
    loadingtext: '載入中...',
    payment: '付款',
    alert: '注意',
    error: '錯誤',
  },
  menu: {
    home: '首頁',
    record: '訂單紀錄',
    favorite: '我的收藏',
    profile: '我的',
    register: '註冊',
    my_wallet: '我的錢包',
    order_list: '訂單列表',
    order_detail: '訂單詳情',
    new_invoice: '新增發票',
    change_invoice: '修改發票',
    list_invoice: '載具及統編',
    o2o_errand: '跑腿',
    waimai: '特約店家',
    errand_buy: '幫我買',
    errand_send: '幫我送',
    ongoing: '進行中的訂單',
    order_evaluation: '評價訂單',
    my_evaluation: '我的評價',
    voucher_list: '優惠券列表',
    voucher: '優惠券',
    search: '搜尋',
    share: '分享',
    account_setting: '帳號設定',
    refund_list: '退單列表',
    activity_list: '活動紀錄',
    viewed_list: '我看過的',
    message_list: '通知',
    sign_in: '簽到送跑幣',
    wallet_detail: '錢包明細',
    point_detail: '跑幣明細',
    point_exchange: '跑幣兌換明細',
    lucky_money_record: '紅包領取紀錄',
    feedback: '意見回饋',
    shopping_cart: '購物車',
  },
  map: {
    selectorDefault: '請選擇...',
    current_location: '現在位置',
    relocating: '重新定位中',
    relocate: '重新定位'
  },
  placeholder: {
    firstname: '請輸入姓氏',
    lastname: '請輸入名字',
    nickname: '請輸入暱稱',
    email: '請輸入信箱地址',
    mobile: '請輸入手機號碼',
    password: '請輸入密碼',
    password_confirmation: '請輸入確認密碼',
    captcha: '請輸入驗證碼',
    smsCaptcha: '請輸入簡訊驗證碼',
    address: {
      label: '新增標籤 (例如: 住家、工作、其它)'
    },
    search_store: '搜尋店家',
    amount: '請輸入金額',
  },
  main: {
    like: '猜你喜歡',
    store: '優質店鋪',
    special_today: '今日特惠',
    storeclass: '區域',
  },
  activity: {
    win: '已中獎',
    lose: '未中獎',
  },
  refund: {
    refund_sn: '退款編號',
    refund_amount: '退款金額',
  },
  share: {
    to: '分享至',
    copy: '複製',
    poster: '海報',
    copy_successful: '複製成功！',
    copy_manual: '請手動複製',
  },
  search: {
    result: '搜尋結果',
    record: '搜尋紀錄',
    hot: '熱門搜尋',
    empty_alert: '請輸入要搜尋的關鍵字',
  },
  address: {
    label_send: '發',
    label_receive: '收',
    label_pickup: '取',
    enable_location_service: '開啟定位服務',
    current_address: '當前地址',
    add_receiver_address: '新增收貨地址',
    add_sender_address: '新增取貨地址',
    modify_receiver_address: '修改收貨地址',
    modify_sender_address: '修改取貨地址',
    default_address: '預設地址',
    sender_address: '取貨地址',
    receiver_address: '收貨地址',
    store_address: '儲存地址',
    address_realname: '姓名',
    address_sender_name: '寄貨人姓名',
    address_receiver_name: '收貨人姓名',
    address_mob_phone: '手機號碼',
    address_management: '地址管理',
    region: '地區',
    address: '地址',
    floor: '樓層與房號',
    mobile_phone: '手機號碼',
    choose_region: '請選擇地區',
    note: '備註',
    label: '地址標籤',
    choose_address: '請選擇地址',
    choose_another_address: '選擇其它地址',
    choose_addresses_too_far_away: '這地址正確嗎？您距離選擇的地址似乎有點遠',
    when_choose_address_not_created_yet: '選擇的地址尚未建立，請先前往建立地址！',
    please_add_receiver_address: '請新增收貨地址',
    please_add_sender_address: '請新增取貨地址'
  },
  member: {
    balance: '錢包',
    point: '跑幣',
    my_order: '我的訂單',
    check_all_orders: '查看全部訂單',
    tools: '常用工具',
    like: '你可能會喜歡',
    edit_member_profile: '會員資料維護',
    upload_avatar: '變更頭像',
    male: '男',
    female: '女',
    modify_password: '變更密碼',
    modify_payment_password: '變更支付密碼',
    modify_phone: '變更手機號碼',
    modify_email: '變更電子信箱',
    modify_email_short: '變更信箱',
    add_email: '新增電子信箱',
    logout: '登出帳號',
    profile: {
      firstname: '姓氏',
      lastname: '名字',
      nickname: '暱稱',
      sex: '性别',
      email: '電子信箱',
      email_bind_status: '信箱狀態',
      email_bind_status_binded: '已驗證',
      email_bind_status_none: '未驗證',
      birthday: '出生日期',
      password: '密碼',
      payment_password: '支付密碼',
      old_password: '舊密碼',
      new_password: '新密碼',
      new_password_confirmation: '確認新密碼',
      old_payment_password: '舊支付密碼',
      new_payment_password: '新支付密碼',
      new_payment_password_confirmation: '確認新密碼',
      delete_account: '刪除帳號',
      delete_account_title: '確定要刪除此帳號嗎？',
      delete_account_message: '確定刪除後所有個人資訊、錢包都會被刪除，且無法復原，此門號也將在三個月內無法被註冊使用',
    },
    verify: '身份驗證',
    verify_method: '驗證方式',
    verify_methods: {
      mobile: '手機',
      email: '電子信箱'
    },
    verify_code: '驗證碼',
    mobile_phone: '手機號碼',
    agreement: '使用者條款',
    privacy_agreement: '隱私權條款',
    bind_email: '驗證信箱',
  },
  chatroom: {
    send: '送出',
    input_message: '請輸入訊息...',
    chat_with_admin: '聯繫客服',
    chat_with_member: '聯繫會員',
    chat_with_distributor: '聯繫騎士',
    client_name_alias_admin: '客服',
    client_name_alias_member: '會員',
    client_name_alias_distributor: '騎士',
    error_no_room_id: '錯誤，請關閉後重新嘗試！',
    error_image_size_too_large: '圖片大小需於 {size} MB 內',
    error_send_message_failed: '傳送訊息失敗，請稍後再試！'
  },
  order: {
    errand_buy_state: {
      0: '已取消',
      10: '待付款',
      20: '確認中',
      23: '待派單',
      24: '待到店',
      26: '待取貨',
      30: '派送中',
      40: '已完成'
    },
    errand_send_state: {
      0: '已取消',
      10: '待付款',
      20: '待接單',
      26: '待取貨',
      30: '派送中',
      40: '已完成'
    },
    status: {
      all: '全部',
      non_payment: '待付款',
      confirm: '確認中',
      pending: '進行中',
      on_the_way: '出發中',
      waiting: '取餐中',
      delivering: '外送中',
      no_comment: '待評價'
    },
    agreement: {
      o2o_errand_send: '幫我送服務協議',
      o2o_errand_buy: '幫我買服務協議'
    },
    o2o_errand_send: {
      deliver_address: '送達地址',
      appointment_time: '任務開始時間',
      consignee: '收貨人',
      shipping_fee: '幫我送運費',
      shipping_fee_detail: '運費明細',
      shipping_fee_total: '合計',
      shipping_fee_rule: '計價規則',
      shipping_fee_loading: '正在計算費用中，請稍後...',
    },
    evaluation: '評論',
    cancel_appointment: '取消預約',
    confirm_appointment: '確定預約',
    appointment_time: '預約時間',
    send_from_where: '從哪裡寄件？',
    send_to_where: '想寄到哪裡？',
    number: '訂單編號',
    goods_price: '單價',
    total_goods: '共計{0}種商品',
    total_price: '合計',
    shipping_fee: '運費',
    freebie: '贈品',
    refunding: '退款中',
    receive_package: '收貨',
    send_receive_code: '發送收貨碼',
    cancel: '取消訂單',
    confirm_cancel: '確定要取消嗎',
    receive_alert: '確定訂單已收貨？',
    refund: '退款',
    deliver_code: '收貨碼',
    comment: '評價',
    complain: '投訴外送員',
    complain_content: '投訴內容',
    delete: '刪除',
    confirm_delete: '確定要刪除嗎',
    pay: '結帳',
    goods_list: '商品清單',
    goods_price_total: '商品金額小計',
    order_now: '直接下訂',
    pickup_now: '立即取貨',
    choose_package_type: '請選擇包裹類型',
    package_type: '包裹類型',
    package_value: '包裹價值',
    package_weight: '包裹重量',
    ask_for_receiver_sign_for_package: '需收貨人當面簽收',
    order_now_note: '若無與店家確認，可能需負擔空跑費！',
    deliver_time: {
      deliver_time: '外送時間',
      go_now: '立即出發',
      today: '今日',
      tomorrow: '明日',
      now: '即時',
      empty_hours: '目前沒有可預約時間',
    },
    note: '備註',
    get_tableware: '索取餐具',
    tableware: '免洗餐具、吸管',
    no_tableware: '不需免洗餐具、吸管',
    input_note: '請輸入備註',
    note_placeholder: '拿辣椒包、餐具',
    confirm_payment: '確認付款方式',
    price_up: '{0} 起',
    deliver_address: '送餐地址',
    order_price: '訂單金額',
    discount: '折扣',
    voucher: '優惠券',
    tips: '小費',
    tips_note: '雨天或高峰時段增加小費可縮短接單時間',
    payment_on_behalf_of_member: '需要騎士先代付嗎 ?',
    need_payment_on_behalf: '須代付',
    payment: '付款方式',
    choose_payment: '請選擇付款方式',
    confirm_mission: '確認任務',
    principal: '委託人',
    invoice: '發票',
    no_invoice: '免用統一發票',
    deliver_dist: '外送路程',
    deliver_fee: '運費',
    destimated_time_of_arrival: '約 {0} 分',
    order: '送出訂單',
    ordering: '正在下訂單...',
    checkout_options: {
      item_sell_out: '若店家品項賣完',
      sell_out: {
        remove_item: '移除該品項',
        remove_order: '刪除整筆訂單',
        remove_order_note: '須負擔發車費用${0}',
        note_me: '請通知我'
      },
    },
    checkout_confirm: {
      sell_out: {
        remove_item: '若有品項售完，我們將直接移除訂單中已售完的品項',
        remove_order: '若有品項售完，我們將直接刪除整筆訂單',
        note_me: '若有品項售完，我們將及時通知您，請隨時注意通知訊息'
      },
      redirect_payment_when_order_created: '訂單生成後，將自動跳轉至刷卡頁面',
      keep_connect: '若任務過程有問題將會連絡您，請隨時注意通知訊息',
      redirect_payment_and_matching_deliver: '即將跳轉至刷卡頁面，付款成功後將開始匹配騎士',
      note: '若訂單有改動，我們將以新訂單的價格進行付款並刷退差額'
    },
    checkout_regret: '等等，再讓我確認一下',
    alerts: {
      no_address: '需要送餐地址',
      no_payment: '需要付款方式',
      no_agree: '需同意幫我買服務協議',
      no_email_binded: '您尚未驗證綁定您的電子信箱，因此開出的電子發票將會先存於本平台，待有中獎時會再通知您。<br>若有需要將電子發票寄送給您的需求，請前往驗證信箱',
    },
    evaluate_placeholder: '請在此輸入評價',
    evaluate_store: '店家評價',
    evaluate_store_item: {
      description: '描述相符',
      service: '服務態度',
      delivery: '出貨速度'
    },
    goods_count: '{0} 份餐點',
    total_amount: '共計',
    order_detail: '訂單詳情',
    order_info: '訂單資訊',
    no_email_binded: {
      continue: '繼續消費',
      goto_bind: '前往驗證',
    }
  },
  order_detail: {
    distributor_info: '外送員資訊',
    complaint: '投訴',
    gift: '贈品',
    order_number: '訂單編號',
    order_time: '訂單時間',
    pay_time: '付款時間',
    appointment_time: '預約時間',
    pickup_time: '取貨時間',
    finish_time: '完成時間',
    payment: '付款方式',
    invoice: '統一發票',
    goods_price: '商品總額',
    shipping_fee: '外送費',
    promotion: '優惠',
    total_price: '付款金額',
    goods_info: '包裹類型',
    goods_weight: '包裹重量',
    goods_value: '包裹價值',
    goods_value_under: '不超過{0}元',
    pay_on_behalf_amount: '外送員代付金額',
    distance_price: '基本運費',
    weight_price: '重量附加費',
    time_price: '特殊時段費',
    gratuity: '小費',
  },
  order_progress: {
    order: '訂單',
    store_name: '店家名稱',
    store_address: '店家地址',
    subtotal_amount: '小計',
    total_amount: '總計',
    pickup_code: '收貨碼',
    estimate: '預估 {0} 分鐘到達',
    expected_time: '預定 {0} 送達',
    today: '今天',
    errand_send_order: {
        matching_deliver: '匹配騎士中',
        matching_deliver_full: '正在為您匹配騎士',
        deliver_to_shipping_address: '前往送貨點',
        deliver_to_pickup_address: '前往取貨點'
    },
    errand_buy_order: {
        distributor_go: '騎士出發',
        store_arrived: '抵達店家',
        delivering: '前往地址'
    },
    errand_send: '幫我送',
    errand_pickup_address: '取貨地點',
    errand_pickup_member: '委託人',
    errand_deliver_address: '送貨地點',
    errand_deliver_name: '收貨人',
    errand_package_info: '物品資訊',
    errand_package_type: '物品類型',
    errand_package_value: '物品價值',
    errand_package_weight: '物品重量',
    errand_on_behalf_amount: '騎士代付',
    errand_tip: '小費',
    errand_expected_time: '預定 {0} 到達取貨',
  },
  tool: {
    wallet: '我的錢包',
    attend: '我要簽到',
    attendance_book: '每日簽到',
    share: '分享連結',
    favorite: '我的收藏',
    refund: '退單管理',
    invoice: '載具及統編',
    address: '收貨地址',
    comment: '我的評價',
    activity: '活動紀錄',
    viewed: '我看過的',
    feedback: '意見回饋',
    points: '跑幣商城',
    profile: '完成會員資料 領取優惠券',
    credit: '信用卡管理',
  },
  register: {
    register_by_mobile: '一般註冊',
    bind_mobile: '綁定手機',
    countdown_to_resend_sms_captcha: '{seconds}s',
    register: '帳號註冊',
    submit: '註冊',
    phone: '手機號碼',
    empty_phone: '請輸入手機號碼',
    notify_phone: '請先輸入手機號碼',
    sms_otp: '簡訊驗證碼',
    empty_sms_otp: '請輸入驗證碼',
    digit_sms_otp: '請輸入6位數驗證碼',
    send_otp: '發送',
    email: '電子信箱',
    empty_email: '請輸入電子信箱',
    notify_email: '請先輸入電子信箱',
    email_otp: '信箱驗證碼',
    empty_email_otp: '請輸入驗證碼',
    digit_email_otp: '請輸入6位數驗證碼',
    password: '密碼',
    empty_password: '請輸入密碼',
    digit_password: '請輸入6-20位數字/英文的密碼',
    confirm_password: '確認密碼',
    empty_confirm_password: '請輸入確認密碼',
    fail_confirm_password: '確認密碼與密碼不一致',
    password_note: '6-20位數字/英文',
    agreetment_note: '按下註冊表示同意',
    agreetment: '用戶協議',
    send_sms_captcha: '發送簡訊驗證碼',
    inviter: '推薦人',
  },
  invite_friends: {
    invite_friends_and_registered: '邀請好友註冊完畢',
    get_gcoin_now: '即可獲得 {coin} 跑幣',
    share_my_invitation_code: '分享我的好友邀請碼',
    share_my_invitation_code_by_app: '透過應用程式分享',
    input_friend_invitation_code: '輸入好友邀請碼',
    error_no_share_payload_please_copy_invitation_code: '無法取得分享資訊, 請複制邀請碼分享',
    input_friend_invitation_code_error: '請輸入正確的邀請碼',
    update_inviter_failed: '更新推薦人失敗',
    update_inviter_successful: '更新推薦人成功',
    device_has_been_invited: '此裝置已使用過邀請碼',
    failed_to_share_copy_your_invitation_code: '分享失敗，請手動複制邀請碼'
  },
  wallet: {
    balance: '可用餘額(元)',
    freeze: '凍結餘額',
    coupon: '優惠券',
    point: '跑幣',
    stored_value_card_balance: '儲值卡餘額',
    add_value: '儲值',
    exchange_point: '跑幣兌換紀錄',
    my_stored_value_card: '我的儲值卡',
    lucky_money_record: '紅包領取紀錄'
  },
  store: {
    tabs: {
      goods: '商品',
      about: '關於',
      info: '優惠'
    },
    evaluate_count: '{0} 則評論',
    address: '地址：{0}',
    phone: '店家電話：',
    non_business_hours: '現在非營業時間',
    business_hours: '營業時間',
    quantity: '數量',
    add_to_cart: '加入購物車',
    buy_now: '立即購買',
    max_quantity: '數量達到上限',
    min_quantity: '數量已達下限',
    out_of_quantity: '庫存不足',
    alerts: {
      cannot_buy_your_own: '不能購買自己的商品',
      no_longer_be_sold: '抱歉，產品已暫停販售',
      out_of_stock: '抱歉，產品暫時缺貨',
      no_deliver: '抱歉, 店家目前無法配送',
    },
    average_time: '平均{0}分鐘送達',
    no_credit: '尚無評價',
    o2o_state: {
      0: '無此店家',
      1: '無此店家',
      2: '此店家暫停接單',
      3: '目前非營業時間，將使用預約單！',
    },
    comments: {
      all: '全部',
      positive: '滿意',
      negative: '不滿意'
    },
    comments_with_content: '只看有內容的評價',
  },
  store_order: {
    general: '綜合排序',
    speed: '速度最快',
    score: '評分最高',
    cost: '起送價最低',
    sale: '銷量排序',
    distance: '離我最近'
  },
  login: {
    login_by_mobile: '一般登入',
    login: '登入',
    forgot_password: '忘記密碼',
    forgot_password_title: '密碼找回',
    mobile: '手機號碼',
    password: '密碼',
    captcha: '驗證碼',
    visitor: '以訪客瀏覽',
  },
  invoice: {
    platform_carrier: '平台載具',
    platform_carrier_note: '存放於平台，待中獎後通知',
    carrier: '電子載具',
    tax_id_number: '統一編號',
    type: '發票類型',
    carrier_code: '載具號碼',
    tax_code: '統編號碼',
    save: '儲存',
    empty_carrier_code: '請填寫載具號碼',
    empty_tax_code: '請填寫統編號碼',
    empty_company: '請填寫公司名稱',
    new: '新增載具或統編',
    edit: '編輯',
    delete: '刪除',
    company_name: '公司名稱',
  },
  payment: {
    add_credit_card_notice: '為了驗證您輸入的信用卡資訊是否正確無誤，我們會在您綁定信用卡時試刷新台幣5元，待驗證通過，便會立即退刷給您。',
    no_payment: '尚無付款方式',
    credit: '信用卡',
    new_credit: '新增信用卡',
    edit_credit: '編輯信用卡',
    card_nickname: '信用卡名稱',
    placeholder: {
      card_nickname: '替信用卡取一個別稱(非必要)',
      card_number: '信用卡號碼',
      expiration_date: '月月 / 年年',
      cvc: '信用卡認證編號(CVC)',
      card_holder: '持卡人姓名'
    },
    save_credit: '保存信用卡',
    in_use: '使用中'
  },
  goods_detail: {
    menu: {
      goods: '商品',
      detail: '詳情',
      evaluation: '評價',
      recommend: '店鋪推薦'
    },
    evaluation: {
      all: '全部',
      good: '好評',
      medium: '中評',
      bad: '差評'
    },
    store_name: '店家',
    favorite: '收藏',
    favorited: '已收藏',
    marketing: {
      sell_commission: '分銷傭金',
      limited_time_offer: '限時折扣',
      lowest_limit: '滿{0}件商品',
      finish_time: '結束',
      buy_get_off: '滿${0}折${1}',
      gift: '贈送',
      take_coupon: '領取店家優惠券',
      buy_get_off_time: '滿額優惠',
      day: '天',
      hour: '時',
      minute: '分',
      second: '秒'
    },
    alert: {
      no_description: '本商品尚無詳情',
      no_review: '本商品尚無評價'
    },
    review: {
      anonymous: '匿名',
      no_content: '無評價',
      store_reply: '店家回覆'
    },
    goto_buy: '請選擇{0}分類數量',
    choiced_amount: '已選數量',
    sell_out: '已售{0}件',
  },
  favorite: {
    store: '收藏店家',
    goods: '收藏商品',
    delete_title: '確認刪除',
    delete_message: '是否要取消收藏此商品'
  },
  voucher: {
    type_list: {
      usable: '未使用',
      used: '已使用',
      expired: '已過期',
    },
    order_min: '訂單滿 {0} 元',
    expired_date: '效期',
    use_it: '去使用',
    store_limited: '店家限定',
    exchange_point: '兌換需 {0} 點',
    exchange_now: '立即兌換',
  },
  shop_cart: {
    minimum_order: '{0}元起送',
    short_by: '還差${0}元起送',
    checkout: '去結算',
  },
  viewed: {
    clear: '清空紀錄',
  },
  message_box: {
    message_type: {
      private: '訊息',
      system: '系統通知',
      comment: '留言',
    },
  },
  sign_in: {
    sign: '簽到',
    continue_days: '已連續{0}天簽到',
    new_period: '進入新週期',
    note: '連續簽到{0}天，可以額外獲得{1}跑幣喔!!',
  },
  point_order: {
    state: {
      all: '全部',
      pay: '待出貨',
      send: '待收貨',
      cancel: '已取消',
      finish: '已完成',
    },
    order_no: '訂單編號',
    summary: '(共計{0}種商品) 合計',
    receive: '收貨',
    cancel: '取消',
    cancel_alert: '確定取消該訂單？',
    receive_alert: '確定訂單已收貨？',
    exchange_detail: '兌換詳情',
    order_time: '下單時間',
    total_amount: '實際付款',
  },
  point_store: {
    title: '跑幣商城',
    login: '登入後查看我的跑幣',
    exchange_rules: '兌換規則',
    point_detail: '跑幣明細',
    exchange_detail: '兌換紀錄',
    rules: '跑幣說明',
    goods_title: '跑幣換好禮',
    goods_desc: '累積跑幣，兌換好禮',
    goods_storage: '剩餘',
    menu: {
      goods: '商品',
      detail: '詳情',
      record: '紀錄',
    },
    select_amount: '請選擇分類數量',
    selected: '已選數量',
    recommend: '平台推薦',
    add_to_cart: '加入購物車',
    buy_now: '立即兌換',
    out_of_stock: '選擇的商品已售完，敬請見諒',
    goods_stock: '剩餘{0}件',
    goods_amount: '數量',
    max_amount_alert: '商品已達到每單最大購買數量',
    min_amount_alert: '不能再少了',
    stock_alert: '商品數量無法供應',
    empty_cart_note: '您的購物車還是空的',
    go_list: '隨便逛逛',
    empty_stock: '已售完',
    few_stock: '僅剩{0}件',
    no_deletable_message: '目前沒有可刪除的商品',
    total_price: '合計',
    checkout: '結算',
    confirm_exchange_title: '確認兌換',
    confirm_exchange: '提交訂單',
    no_address_alert: '請先新增收貨地址',
    order_message: '訂單留言',
    total_order_point: '跑幣合計',
    no_record_message: '還沒有人兌換過，快來兌換！',
    photos: '商品照片',
    empty_desc: '此商品暫無詳情',
  },
  feedback: {
    input: '回饋內容',
    captcha: '驗證碼',
    content: '內容',
    please_input_captcha: '請先輸入圖片驗證碼',
    please_input_feedback_content: '請先輸入回饋內容',
    captcha_error: '驗證碼錯誤'
  },
  goods_type: {
    food: '食品飲料',
    flower: '鮮花',
    cake: '蛋糕',
    document: '文件',
    fruit: '水果生鮮',
    id: '證件',
    home_appliances: '數位家電',
    clothes: '服飾鞋帽',
    other: '其他',
  },
  errand_send_value: {
    value_1: '50元以下',
    value_2: '50~100元',
    value_3: '100~500元',
    value_4: '500~1000元',
    value_5: '1000~5000元',
    value_6: '5000~10000元',
  },
  evaluation: {
    score: '評分',
    comment_input: '請在此輸入評價',
  },
  complaint: {
    title: '投訴詳情',
    subject: '投訴主題',
    upload: '上傳照片',
    content: '投訴內容',
    crop_title: '剪裁圖片',
    distributor_title: '外送員投訴',
    distributor_date: '投訴於(日期)',
  },
  /**
   *
   * Errors
   *
   */
  guest: {
    need_more_please_login: '想使用更多服務，請先登入'
  },
  errors: {
    error: '錯誤',
    browser_version_unsupported_geolocation: '瀏覽器版本無法定位。',
    please_check_geolocation_permission: '請確認是否有開啟地理定位權限',
    timeout: '逾時',
    unavailable: '未知錯誤',
    runtime_error: '執行錯誤，請重新嘗試',
  },
  validation: {
    required: '此欄位為必填',
    maxLength: '此欄位至多 {max} 字元',
    minLength: '此欄位至少 {min} 字元',
    email: '此信箱地址格式不正確',
    sameAs: '與 {eq} 欄位不相同',
    mobile: '此電話號碼無效',
    validCarrierCode: '載具格式不正確',
  }
}
